import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import { FormattedMessage } from 'react-intl';
import { membershipMessages } from 'src/features/membership/utils/messages';
import IdentifiersTable from 'src/features/membership/components/table/IdentifiersTable';
import MembershipCloudUsersTable from 'src/features/MembershipCloudUsers/components/tables/MembershipCloudUsersTable';
import { membershipUsersMessages } from 'src/features/MembershipCloudUsers/utils/messages';
import { MEMBERSHIP_USER_ACCESS_LEVEL } from 'src/features/membership/types';
import { userMessages } from 'src/features/users/utils/messages';
import { MembershipInvitationTable } from 'src/features/MembershipCloudUsers/components/MembershipInvitationTable';

type ClientsTablesProps = {
    membershipId: string;
    accessLevel?: MEMBERSHIP_USER_ACCESS_LEVEL;
};

const ClientsTables = ({ membershipId, accessLevel }: ClientsTablesProps) => {
    const userIsMemberOrAdmin =
        accessLevel === MEMBERSHIP_USER_ACCESS_LEVEL.MEMBER || accessLevel === MEMBERSHIP_USER_ACCESS_LEVEL.ADMIN;

    return (
        <div className="grid flex-3 grid-cols-1 pr-8">
            <Tabs defaultValue="identifiers">
                <TabsList>
                    <TabsTrigger value="identifiers">
                        <FormattedMessage {...membershipMessages.identifiers} />
                    </TabsTrigger>
                    {userIsMemberOrAdmin && (
                        <>
                            <TabsTrigger value="membership-users">
                                <FormattedMessage {...membershipUsersMessages.membershipUsers} />
                            </TabsTrigger>
                            <TabsTrigger value="membership-users-invitations">
                                <FormattedMessage {...userMessages.invitations} />
                            </TabsTrigger>
                        </>
                    )}
                </TabsList>
                <TabsContent value="identifiers" className="w-full">
                    <IdentifiersTable membershipId={membershipId} accessLevel={accessLevel} isClient={true} />
                </TabsContent>
                {userIsMemberOrAdmin && (
                    <>
                        <TabsContent value="membership-users" className="w-full">
                            <MembershipCloudUsersTable
                                membershipId={membershipId}
                                isClient={true}
                                accessLevel={accessLevel}
                            />
                        </TabsContent>
                        <TabsContent value="membership-users-invitations">
                            <MembershipInvitationTable
                                membershipId={membershipId}
                                isClient={true}
                                accessLevel={accessLevel}
                            />
                        </TabsContent>
                    </>
                )}
            </Tabs>
        </div>
    );
};

export default ClientsTables;
